<template>
  <input
    v-if="Array.isArray(checked)"
    @click="click"
    class="checkbox-color h-4 w-4 flex-shrink-0 bg-AkWhite border border-AkGreyscaleMediumLtGrey appearance-none checked:border-0 md:h-6 md:w-6"
    type="checkbox"
    :checked="checked.includes(value)"
  />
  <input
    v-else
    @click="$emit('input', !checked)"
    class="checkbox-color h-4 w-4 flex-shrink-0 bg-AkWhite border border-AkGreyscaleMediumLtGrey appearance-none checked:border-0 md:h-6 md:w-6"
    type="checkbox"
    :checked="checked"
  />
</template>

<script>
export default {
  name: 'CheckboxColor',
  props: ['checked', 'value'],
  model: {
    prop: 'checked',
    event: 'input'
  },
  methods: {
    click () {
      if (this.checked.includes(this.value)) {
        this.checked.splice(this.checked.indexOf(this.value), 1)
      } else {
        this.checked.push(this.value)
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
input[type="checkbox"]:checked
  background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 64 64' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M51.765 15L56 19.235 30.527 44.704l.061.061L26.353 49 8 30.649l4.235-4.235L26.292 40.47 51.765 15z'/%3e%3c/svg%3e")
</style>
